import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type AccountListResponse = {
  accounts: {
    id: string
    name: string
    institutionName: string
    accountMask: string
    balance: number
    currencyCode: string
    isPrimary: boolean
    modificationDate: string
    recentTransfers: [
      {
        externalTransferId: string
        amount: {
          value: number
          currencyCode: {
            value: string
            displayName: string
          }
        }
        date: string
        senderName: string
        recipientName: string
        senderAccount: string
        recipientAccount: string
        isRefunded: boolean
        recipientAddress: {
          streetNumberAndName: string
          apartmentNumber: string
          city: string
          zipCode: string
          state: string
          country: string
        }
      }
    ]
  }[]
}

type UseAccountListParams = {
  enabled?: boolean
}

export function useAccountList({ enabled = true }: UseAccountListParams = {}) {
  return useQuery<AccountListResponse>({
    queryKey: ["accountList"],
    enabled,
    queryFn: async () => {
      const response = await fetcher(
        "/Account/List",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
  })
}
